import * as React from 'react'
import { memo } from 'react'
const SvgBottle = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7.816 16">
    <path d="M.644 16a.62.62 0 0 1-.46-.184.62.62 0 0 1-.184-.46V6.413a.55.55 0 0 1 .138-.368.8.8 0 0 1 .322-.23l.874-.345a2.85 2.85 0 0 0 1.08-.655 1.93 1.93 0 0 0 .391-1.368v-2.8a.62.62 0 0 1 .184-.46.62.62 0 0 1 .46-.184h.92a.62.62 0 0 1 .46.184.62.62 0 0 1 .184.46v2.8a1.9 1.9 0 0 0 .4 1.368 3 3 0 0 0 1.092.655l.9.345a.63.63 0 0 1 .3.23.6.6 0 0 1 .115.368v8.943a.62.62 0 0 1-.184.46.62.62 0 0 1-.46.184Zm2.8-14.322h.92V.644h-.92Zm-2.8 7.035h6.529v-2.3l-.9-.345a3.6 3.6 0 0 1-1.391-.862 2.5 2.5 0 0 1-.517-1.759V2.321h-.92v1.126a2.5 2.5 0 0 1-.517 1.759 3.6 3.6 0 0 1-1.391.862l-.9.345Zm0 6.644h6.529V12.69H.644Z" />
  </svg>
)
const Memo = memo(SvgBottle)
export default Memo
